<template>
  <div id="shippingMap" ref="shippingMap">
    <div class="legend">States where we ship</div>
  </div>
</template>

<script>
import { mapJSON } from '#common/config/mapJSON'

export default {
  props: {
    states: {
      type: Object,
      require: true,
      default: () => {},
    },
  },
  data() {
    return {
      projection: undefined,
      path: undefined,
    }
  },
  created() {
    window.addEventListener('resize', this.resize)
  },
  unmounted() {
    window.removeEventListener('resize', this.resize)
  },
  mounted() {
    const shippingStates = [].concat(
      this.states.alt,
      this.states.main,
      this.states.private_label_only,
    )

    const wrapper = this.$refs.shippingMap
    const width = wrapper.clientWidth
    const height = width * 0.67

    this.projection = this.$d3()
      .geoAlbersUsa()
      .scale(width * 1.15)
      .translate([width / 2.25, height / 2])

    const map = this.$d3()
      .select(`#${wrapper.id}`)
      .insert('svg', ':first-child')
      .attr('width', width)
      .attr('height', height)

    this.path = this.$d3().geoPath().projection(this.projection)

    // Merge shipping states into mapJSON.
    for (let ships = 0; ships < shippingStates.length; ships++) {
      for (let state = 0; state < mapJSON.features.length; state++) {
        if (
          shippingStates[ships] ===
          mapJSON.features[state].properties.abbreviation
        ) {
          mapJSON.features[state].properties.shipto = true
          break
        }
      }
    }

    // Draw the map.
    map
      .selectAll('path')
      .data(mapJSON.features)
      .enter()
      .append('path')
      .attr('d', this.path)
      .attr('class', function (d) {
        if (d.properties.shipto) {
          return 'shipto'
        } else {
          return ''
        }
      })

    this.resize()
  },
  methods: {
    resize() {
      const width = this.$refs.shippingMap.clientWidth
      const height = width * 0.67

      this.projection.scale(width * 1.15).translate([width / 2.25, height / 2])

      this.$d3()
        .select(`#${this.$refs.shippingMap.id}`)
        .select('svg')
        .attr('width', width)
        .attr('height', height)
        .selectAll('path')
        .attr('d', this.path)
    },
  },
}
</script>

<style lang="scss">
#shippingMap {
  max-width: 97vw;
  svg {
    path {
      fill: #c5c5c3;
      stroke: #fff;
      stroke-width: 0.75;
      &.shipto {
        fill: #680020;
      }
    }
  }
  .legend {
    float: right;
    position: relative;
    padding-left: 1.5rem;
    color: #333;
    &:before {
      content: ' ';
      background: #680020;
      height: 1rem;
      width: 1rem;
      position: absolute;
      top: 0;
      left: 0;
      margin-top: 0.25rem;
    }
  }
}
</style>
